import * as React from 'react';

import { cn } from '../lib/utils';

/**
 * The only loading affordance in this product. Tables and cards render a
 * Skeleton in their own shape while data fetches — never a spinner.
 */
function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
